// eslint-disable-next-line
import { getWeatherStations } from '@/api/index';

export default {
  namespaced: true,
  state() {
    return ({
      station: {},
      stations: [],
    });
  },
  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */
  },
  mutations: {
    
    async setStation(state, payload) {
      state.station = payload;
    },
    setStations(state, payload) {
      state.stations = payload;
    },
  },
  actions: {
    async apiGetStations(context) {
      await getWeatherStations(null).then((stations) => {
        context.commit('setStations', stations);
      });
    },

  },
};
